<template>
  <!-- start gallery -->
  <div id="gallery">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-sm-6" v-if="!isTop">
          <h3 style="color:#58585a;">Printer Counters Dashboard Screens</h3>
        </div>
        <div class="col-md-6 col-sm-6" v-for="img in activeGallery" style="padding-bottom: 50px;">
          <div class="media">
            <div class="media-body wow fadeIn" style="text-align: center;">
              <h4>{{img.title}}</h4>
              <img :src="img.src" alt="Printer Counters" style="width: 100%;" />
            </div>
          </div>
        </div>
      </div>
      <tryBtn></tryBtn>
    </div>
  </div>
  <!-- end gallery -->
</template>
<script>
  import tryBtn from './tryBtn'
  export default {
    name: 'gallery',
    props: ['isTop'],
    components: { tryBtn },
    data () {
      return {
        galleryTop: [
          {
            title: 'Dynamic RealTime Dashboard',
            src: '../../../static/img/landing/תמונה_30.jpg'
          },
          {
            title: 'Fully secure cloud based system',
            src: '../../../static/img/landing/System Diagram0.png'
          }
        ],
        gallery: [
          {
            title: 'RealTime Active Dashboard',
            src: '../../../static/img/landing/תמונה_30.jpg'
          },
          {
            title: 'Printer Counters and Toner Level Monitoring',
            src: '../../../static/img/landing/תמונה_40.jpg'
          },
          {
            title: 'Fast & Easy Reporting',
            src: '../../../static/img/landing/תמונה_20.jpg'
          },
          {
            title: 'Printer Counters History Log',
            src: '../../../static/img/landing/תמונה_10.jpg'
          }
        ]
      }
    },
    computed: {
      active () {
        return this.activeMenu === 'HOME'
      },
      activeGallery () {
        if (this.isTop) {
          return this.galleryTop
        } else {
          return this.gallery
        }
      }
    }
  }

</script>
<style>
  #info {
    background-color: #ecf0f5;
  }
</style>



// WEBPACK FOOTER //
// gallery.vue?64e2a3b0